import React from 'react';
import './sectionHeader.scss';
import classnames from 'classnames';

type SectionHeaderProps = {
  children: React.ReactNode;
  className?: string;
  isRequired?: boolean;
  isSubsection?: boolean;
};

const SectionHeader = ({ children, className = '', isRequired = false, isSubsection = false }: SectionHeaderProps) => {
  const styles = classnames('section-header', className, {
    required: isRequired,
  });

  return <div className={styles}>{isSubsection ? <h4>{children}</h4> : <h3>{children}</h3>}</div>;
};

export default SectionHeader;
